/* MYK DEALS product page · Website Vertex */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var fmt = format || 'Rs.{{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function delimit(num, precision, thousands, decimal) {
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    // Drop ".00" like Liquid's money_without_trailing_zeros
    var precision = cents % 100 === 0 ? 0 : 2;
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, precision, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, precision, "'", '.'); break;
      default: value = delimit(cents, precision, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function MykProduct(root) {
    this.root = root;
    this.moneyFormat = root.getAttribute('data-money-format') || 'Rs.{{amount}}';
    this.bundlePercent = parseInt(root.getAttribute('data-bundle-percent'), 10) || 0;
    var json = root.querySelector('[data-product-json]');
    this.product = json ? JSON.parse(json.textContent) : null;
    this.form = root.querySelector('[data-myk-form]');
    this.variantInput = root.querySelector('[data-variant-input]');
    this.qtyInput = root.querySelector('[data-qty]');
    this.toast = root.querySelector('[data-toast]');
    this.errorEl = root.querySelector('[data-error]');
    this.initGallery();
    this.initVariants();
    this.initQty();
    this.initPacks();
    this.initCart();
    this.initSticky();
  }

  /* ---------- Gallery ---------- */
  MykProduct.prototype.initGallery = function () {
    var self = this;
    var track = this.root.querySelector('[data-track]');
    if (!track) return;
    this.track = track;
    this.slides = Array.prototype.slice.call(track.querySelectorAll('.myk-gallery__slide'));
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-thumb]'));
    this.current = 0;

    this.thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { self.goTo(parseInt(btn.getAttribute('data-thumb'), 10)); });
    });
    var prev = this.root.querySelector('[data-prev]');
    var next = this.root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.current - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.current + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        self.setActive(idx);
        ticking = false;
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.current - 1); }
    });

    // Lightbox
    var dialog = this.root.querySelector('[data-lightbox]');
    var dialogImg = this.root.querySelector('[data-lightbox-img]');
    if (dialog && typeof dialog.showModal === 'function') {
      this.root.querySelectorAll('[data-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var img = btn.querySelector('img');
          dialogImg.src = btn.getAttribute('data-zoom');
          dialogImg.alt = img ? img.alt : '';
          dialog.showModal();
        });
      });
      this.root.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
  };

  MykProduct.prototype.setActive = function (idx) {
    if (!this.slides || !this.slides.length) return;
    idx = Math.max(0, Math.min(idx, this.slides.length - 1));
    if (idx !== this.current) {
      // pause any playing video on the slide we left
      var leaving = this.slides[this.current];
      if (leaving) leaving.querySelectorAll('video').forEach(function (v) { v.pause(); });
    }
    this.current = idx;
    this.thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    var active = this.thumbs[idx];
    if (active && active.parentElement) {
      var p = active.parentElement;
      var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
      p.scrollTo({ left: left, behavior: 'smooth' });
    }
  };

  MykProduct.prototype.goTo = function (idx) {
    if (!this.track || !this.slides.length) return;
    var n = this.slides.length;
    idx = (idx + n) % n;
    this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: 'smooth' });
    this.setActive(idx);
  };

  MykProduct.prototype.goToMedia = function (mediaId) {
    if (!this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i); return; }
    }
  };

  /* ---------- Variants ---------- */
  MykProduct.prototype.initVariants = function () {
    var self = this;
    this.fieldsets = Array.prototype.slice.call(this.root.querySelectorAll('[data-option-index]'));
    if (!this.fieldsets.length || !this.product) return;
    this.fieldsets.forEach(function (fs) {
      fs.querySelectorAll('[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          fs.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          var label = fs.querySelector('[data-option-label]');
          if (label) label.textContent = btn.getAttribute('data-option-value');
          self.onOptionChange();
        });
      });
    });
    this.markUnavailable();
  };

  MykProduct.prototype.selectedOptions = function () {
    return this.fieldsets.map(function (fs) {
      var a = fs.querySelector('.is-active');
      return a ? a.getAttribute('data-option-value') : null;
    });
  };

  MykProduct.prototype.markUnavailable = function () {
    var self = this;
    var selected = this.selectedOptions();
    this.fieldsets.forEach(function (fs, idx) {
      fs.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var test = selected.slice();
        test[idx] = btn.getAttribute('data-option-value');
        var v = self.findVariant(test);
        btn.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  };

  MykProduct.prototype.findVariant = function (options) {
    var variants = this.product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < options.length; j++) {
        if (variants[i].options[j] !== options[j]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  };

  MykProduct.prototype.onOptionChange = function () {
    var variant = this.findVariant(this.selectedOptions());
    this.markUnavailable();
    this.updateVariant(variant);
  };

  MykProduct.prototype.updateVariant = function (variant) {
    var self = this;
    var addBtns = this.root.querySelectorAll('[data-add], [data-buy-now]');
    var addLabel = this.root.querySelector('[data-add-label]');
    if (!variant) {
      addBtns.forEach(function (b) { b.disabled = true; });
      if (addLabel) addLabel.textContent = 'Unavailable';
      return;
    }
    this.variant = variant;
    if (this.variantInput) this.variantInput.value = variant.id;

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    this.root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price, self.moneyFormat); });
    this.root.querySelectorAll('[data-compare]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) el.textContent = formatMoney(variant.compare_at_price, self.moneyFormat);
    });
    var save = this.root.querySelector('[data-save]');
    if (save) {
      save.hidden = !onSale;
      if (onSale) save.textContent = 'You save ' + formatMoney(variant.compare_at_price - variant.price, self.moneyFormat);
    }
    var badge = this.root.querySelector('[data-off-badge]');
    if (badge) {
      badge.hidden = !onSale;
      if (onSale) badge.textContent = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF';
    }
    var single = this.root.querySelector('[data-pack-single]');
    var dbl = this.root.querySelector('[data-pack-double]');
    if (single) single.textContent = formatMoney(variant.price, self.moneyFormat);
    if (dbl) dbl.textContent = formatMoney(Math.floor(variant.price * 2 * (100 - this.bundlePercent) / 100), self.moneyFormat);

    addBtns.forEach(function (b) { b.disabled = !variant.available; });
    if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

    if (variant.featured_media && variant.featured_media.id) this.goToMedia(variant.featured_media.id);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  /* ---------- Quantity & packs ---------- */
  MykProduct.prototype.initQty = function () {
    var self = this;
    var minus = this.root.querySelector('[data-qty-minus]');
    var plus = this.root.querySelector('[data-qty-plus]');
    if (!this.qtyInput) return;
    function set(n) {
      self.qtyInput.value = Math.max(1, n || 1);
      self.syncPacks();
    }
    if (minus) minus.addEventListener('click', function () { set(parseInt(self.qtyInput.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { set(parseInt(self.qtyInput.value, 10) + 1); });
    this.qtyInput.addEventListener('change', function () { set(parseInt(self.qtyInput.value, 10)); });
  };

  MykProduct.prototype.initPacks = function () {
    var self = this;
    this.packs = Array.prototype.slice.call(this.root.querySelectorAll('[data-pack]'));
    this.packs.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (self.qtyInput) self.qtyInput.value = radio.value;
        self.syncPacks();
      });
    });
  };

  MykProduct.prototype.syncPacks = function () {
    if (!this.packs || !this.packs.length || !this.qtyInput) return;
    var q = parseInt(this.qtyInput.value, 10) || 1;
    this.packs.forEach(function (radio) {
      var on = (q >= 2 && radio.value === '2') || (q < 2 && radio.value === '1');
      radio.checked = on;
      radio.closest('.myk-pack').classList.toggle('is-active', on);
    });
  };

  /* ---------- Cart ---------- */
  MykProduct.prototype.initCart = function () {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.addToCart(false, self.form.querySelector('[data-add]'));
      });
    }
    this.root.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.addToCart(true, btn); });
    });
  };

  MykProduct.prototype.addToCart = function (goToCheckout, button) {
    var self = this;
    var id = this.variantInput ? this.variantInput.value : null;
    var qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
    if (!id) return;
    if (this.errorEl) this.errorEl.hidden = true;
    if (button) button.classList.add('is-loading');

    var body = { items: [{ id: Number(id), quantity: qty }] };
    if (!goToCheckout) body.sections = 'cart-icon-bubble';

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        if (goToCheckout) {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
          return;
        }
        self.refreshCartBubble(r.data);
        self.showToast(qty > 1 ? qty + ' items added to cart' : 'Added to cart');
        document.dispatchEvent(new CustomEvent('myk:cart-added', { detail: r.data }));
      })
      .catch(function (err) {
        if (self.errorEl) {
          self.errorEl.textContent = err.message;
          self.errorEl.hidden = false;
        }
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  };

  MykProduct.prototype.refreshCartBubble = function (data) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data && data.sections && data.sections['cart-icon-bubble']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = data.sections['cart-icon-bubble'];
      var fresh = tmp.querySelector('.shopify-section') || tmp;
      bubble.innerHTML = fresh.innerHTML;
    }
  };

  MykProduct.prototype.showToast = function (text) {
    if (!this.toast) return;
    var self = this;
    this.toast.querySelector('[data-toast-text]').textContent = text;
    this.toast.hidden = false;
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { self.toast.hidden = true; }, 6000);
  };

  /* ---------- Sticky bar ---------- */
  MykProduct.prototype.initSticky = function () {
    var sticky = this.root.querySelector('[data-sticky]');
    var anchor = this.root.querySelector('.myk-actions');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    var btn = sticky.querySelector('button');
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    });
    io.observe(anchor);
  };

  function init() {
    document.querySelectorAll('[data-myk-product]').forEach(function (root) {
      if (root.__myk) return;
      root.__myk = new MykProduct(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
